//
// Copyright (c) 2011 - 2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.service('LabelsService', [
    'LabelsApiService',
    'rx',
    'UniversalImageActionsService',
    'UniversalImageActionsApiService',
    function(
      LabelsApiService,
      rx,
      UniversalImageActionsService,
      UniversalImageActionsApiService,
    ) {
      const self = this;
      let initialized = false;

      this.labels = new rx.BehaviorSubject([]);

      this.initialize = function(universalItemId) {
        if (!initialized) {
          initialized = true;

          rx.Observable.fromPromise(UniversalImageActionsService.getItemMetadataAsync(universalItemId))
            .map(metadata => metadata.userTags)
            .subscribe((newLabels) => {
              self.labels.next(newLabels);
            });
        }
      };

      this.refreshLabels = function(itemId) {
        // hit the api directly to make sure we're getting up to date labels
        const promise = UniversalImageActionsApiService.getItemMetadataAsync(itemId);
        rx.Observable.fromPromise(promise).map(metadata => metadata.userTags).subscribe((newLabels) => {
          self.labels.next(newLabels);
        });
      };

      this.saveLabelsAsync = function(itemId, newLabels) {
        self.labels.next(newLabels);
        return UniversalImageActionsApiService.saveTagsAsync(itemId, newLabels);
      };

      this.getTagsByStringAsync = function(tagString, limit) {
        return LabelsApiService.searchLabelsAsync(tagString, limit);
      };
    },
  ]);
})();
